import React from 'react';
import { string, bool } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import css from './BookingChanges.module.css';

const PricingDetails = ({
  isCustomer,
  formattedCustomerOriginalPrice,
  formattedNewCustomerPrice,
  formattedPriceDifferenceForCustomer,
  isProvider,
  formattedNewProviderPrice,
  formattedProviderOriginalPrice,
  formattedPriceDifferenceForProvider,
}) => {
  return (
    <div className={css.pricingDetails}>
      <div className={css.pricingDetailsHeader}>
        {isCustomer && <FormattedMessage id="BookingChanges.pricingDetails" />}
        {isProvider && <FormattedMessage id="BookingChanges.landownerPayout" />}
      </div>

      <div className={css.pricingDetailsItem}>
        {isCustomer && (
          <>
            <FormattedMessage id="BookingChanges.originalPrice" />
            <span>{formattedCustomerOriginalPrice}</span>
          </>
        )}

        {isProvider && (
          <>
            <FormattedMessage id="BookingChanges.originalPayout" />
            <span>{formattedProviderOriginalPrice}</span>
          </>
        )}
      </div>

      <div className={css.pricingDetailsItem}>
        {isCustomer && (
          <>
            <FormattedMessage id="BookingChanges.newPrice" />
            <span>{formattedNewCustomerPrice}</span>
          </>
        )}

        {isProvider && (
          <>
            <FormattedMessage id="BookingChanges.newPayout" />
            <span>{formattedNewProviderPrice}</span>
          </>
        )}
      </div>

      <div className={css.pricingDetailsItem}>
        <b>
          {isCustomer && <FormattedMessage id="BookingChanges.priceDifferenceCustomer" />}
          {isProvider && <FormattedMessage id="BookingChanges.priceDifferenceProvider" />}
        </b>
        {isCustomer && <b>{formattedPriceDifferenceForCustomer}</b>}
        {isProvider && <b>{formattedPriceDifferenceForProvider}</b>}
      </div>
    </div>
  );
};

PricingDetails.defaultProps = {
  formattedCustomerOriginalPrice: null,
  formattedNewCustomerPrice: null,
  formattedPriceDifferenceForCustomer: null,
  formattedNewProviderPrice: null,
  formattedProviderOriginalPrice: null,
  formattedPriceDifferenceForProvider: null,
};

PricingDetails.propTypes = {
  isCustomer: bool.isRequired,
  formattedCustomerOriginalPrice: string,
  formattedNewCustomerPrice: string,
  formattedPriceDifferenceForCustomer: string,
  isProvider: bool.isRequired,
  formattedNewProviderPrice: string,
  formattedProviderOriginalPrice: string,
  formattedPriceDifferenceForProvider: string,
};

export default PricingDetails;
